import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import { faComments } from "@fortawesome/free-solid-svg-icons";

import Imagen1 from "../../../images/modulo13/papas.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad2Actividad7.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo13.content[1];
  const infoAct = modulo13.content[1].activities[8];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo13.content[1].name}: ${modulo13.content[1].activities[9].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[9].path}`,
    titlePrev: `${modulo13.content[1].name}: ${modulo13.content[1].activities[7].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[7].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul>
        <li>Sigue trabajando con un compañero, compañera o familiar.</li>
        <li>Lean el siguiente caso y observen la ilustración.</li>
      </ul>

      <div className="row align-items-center">
        <div className="col-md-6 col-12">
          <p className="fs-5">
            En el Perú encontramos muchas variedades de papa. Algunas de ellas
            son conocidas como papas nativas. Estas se suelen sembrar en la
            sierra, están adaptadas a la altura y usan abonos naturales.
          </p>
          <p className="fs-5">
            En los últimos años, sin embargo, el cambio climático ha venido
            afectando a las papas nativas. En la comunidad de Paru Paru, en
            Pisac (Cuzco), los campesinos ahora las tienen que sembrar más
            arriba de los 3,500 metros sobre el nivel del mar para que no las
            afecten las plagas. Esto ocurre porque ahora las temperaturas son
            más elevadas.
          </p>
          <p>
            <small>
              (Adaptado de:{" "}
              <a
                href="http://cambia.pe/cambio-climatico-en-cusco-y-la-proteccionde-
la-papa-nativa/"
              >
                http://cambia.pe/cambio-climatico-en-cusco-y-la-proteccionde-
                la-papa-nativa/
              </a>
              )
            </small>
          </p>
        </div>
        <div className="col-md-6 col-12">
          <img src={Imagen1} className="img-fluid" alt="Peruanos" />
        </div>
      </div>

      <div className="row">
        <div className="col-lg-10 col-12">
          <ul className="mt-5">
            <li>
            Ahora, conversen acerca de lo siguiente:
            </li>
          </ul>

          <p>¿Cuál es el problema que nos presenta el texto?</p>
          <textarea className="form-control mb-4" rows={3} />
          <p>¿Qué se está haciendo para solucionar el problema?</p>
          <textarea className="form-control mb-4" rows={3} />
          <p>
            ¿Qué semejanzas y diferencias encuentras con el caso de la Actividad
            6?
          </p>
          <textarea className="form-control" rows={3} />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            En esta actividad, se trabajará de modo similar que con la anterior.
            Lea las dos primeras indicaciones: Sigue trabajando en parejas. Lean
            el siguiente caso y observen la ilustración. Pida a un o una
            estudiante que describa en voz alta la ilustración y luego pida a
            otro que lea en voz alta el caso.
          </li>
          <li>
            Lea la siguiente indicación: Ahora, conversa con tu compañero o
            compañera acerca de lo siguiente: ¿Cuál es el problema que nos
            presenta el texto? ¿Qué se está haciendo para solucionar el
            problema? ¿Qué semejanzas y diferencias encuentras con el caso de la
            Actividad 6?
          </li>
          <li>
            Dé un tiempo para que trabajen y retome sus
            respuestas a las dos primeras preguntas. Por ejemplo:- “¿Cuál es el
            problema que nos presenta el texto? (Posible respuesta: El cambio
            climático ha afectado el cultivo de papas nativas). - ¿Qué se está
            haciendo para solucionar el problema? (Posible respuesta: Los
            agricultores tienen que sembrar a una mayor altitud para que el
            cultivo tenga éxito)”.
          </li>
          <li>
            Haga especial hincapié en la última pregunta de esta actividad: ¿Qué
            semejanzas y diferencias encuentras con el caso de la Actividad 6?
            Puede hacer un cuadro para comparar los dos casos. Por
            ejemplo:
          </li>
        </ul>
        <div className="border p-3 pb-0">
          <p>
            <strong>Semejanzas</strong>
          </p>
          <p>
            - Ambos casos tratan sobre recursos naturales.
            <br />- Ambos casos muestran las dificultades que suponen los
            recursos presentados.
          </p>
        </div>
        <div className="border p-3 pb-0">
          <p>
            <strong>Diferencias</strong>
          </p>
          <p>
            - En el primer caso el recurso está expuesto a la extracción ilegal
            por parte del ser humano; en el segundo caso, el recurso está
            expuesto a las adversidades del cambio climático.
            <br />
            - En el primer caso, la responsabilidad del problema recae en la
            empresa, los pobladores locales y el Estado. En el segundo caso, la
            responsabilidad de las personas no es tan directa.
            <br />- En el primer caso, los pobladores locales se suman al
            problema en la ilegalidad. En el segundo caso, los pobladores
            locales buscan una solución para afrontar el problema.
          </p>
        </div>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
